var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/dynamicdashboard.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"container-fluid\">\r\n    <div class=\"page-header mt-4\">        \r\n        <h1>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Title"), env.opts.autoescape);
output += "</h1>\r\n        <hr>\r\n    </div>\r\n    <div class=\"row\">\r\n        ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"DashboardTiles");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("dashboardTile", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "        \r\n        <div class=\"col col-12 col-md-6 col-lg-4 mb-4\" \r\n            ";
if(runtime.memberLookup((t_4),"Url")) {
output += " onclick=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Url"), env.opts.autoescape);
output += "\" ";
;
}
output += ">\r\n                <div \r\n                ";
if(runtime.memberLookup((t_4),"Highlighted")) {
output += " \r\n                    class=\"card ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"MenuID")?"panel-dashboard-pointer":""), env.opts.autoescape);
output += " card-dashboard card-primary ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"Url")?"disabled":""), env.opts.autoescape);
output += "\" \r\n                ";
;
}
else {
output += " \r\n                    class=\"card ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"MenuID")?"panel-dashboard-pointer":""), env.opts.autoescape);
output += " card-dashboard card-default ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"Url")?"disabled":""), env.opts.autoescape);
output += "\" \r\n                ";
;
}
output += "\r\n                ";
if(runtime.memberLookup((t_4),"MenuID")) {
output += " \r\n                    data-menu-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"MenuID"), env.opts.autoescape);
output += "\" \r\n                ";
;
}
output += ">\r\n                ";
if(runtime.memberLookup((t_4),"Highlighted")) {
output += " \r\n                    <div class=\"card-body bg-primary text-white\">\r\n                ";
;
}
else {
output += "\r\n                    <div class=\"card-body bg-secondary \">\r\n                ";
;
}
output += "\r\n                    <div class=\"row align-items-center\">\r\n                        <div class=\"col col-2\">\r\n                            <i class=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Icon"), env.opts.autoescape);
output += " fa-3x\" aria-hidden=\"true\"></i>\r\n                        </div>\r\n                        <div class=\"col col-4\">\r\n                            <h1>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Amount"), env.opts.autoescape);
output += "</h1>\r\n                        </div>\r\n                        <div class=\"col col-6\">\r\n                            <h3 class=\"text-right\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Title"), env.opts.autoescape);
output += "</h3>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ";
;
}
}
frame = frame.pop();
output += "\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/dynamicdashboard.html"] , dependencies)